import { render, staticRenderFns } from "./BucketSections.vue?vue&type=template&id=d8525260&"
import script from "./BucketSections.vue?vue&type=script&lang=js&"
export * from "./BucketSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports